import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import img1 from '../Assets/products/p1.jpeg';
import img2 from '../Assets/products/p2.jpeg';
import img3 from '../Assets/products/p3.jpeg';
import leaf1 from '../Assets/products/l1.png';
import leaf2 from '../Assets/products/l2.png';
import leaf3 from '../Assets/products/l3.png';
import leaf4 from '../Assets/products/l4.png';

const ImageSlider2 = () => {
  const slides = [
    { backgroundImage: `url(${img1})`, productn1: "Aryaa's Idli Mix", productn2: 'Dosa Mix' },
    { backgroundImage: `url(${img2})`, productn1: "Aryaa's Soft", productn2: 'Chappathi Mix' },
    { backgroundImage: `url(${img3})`, productn1: "Aryaa's Soft", productn2: 'Idiyapam Mix' },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const [mouseX, setMouseX] = useState(0);
  const [mouseY, setMouseY] = useState(0);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMouseX(e.clientX);
      setMouseY(e.clientY);
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  const prevSlide = () => {
    setDirection(-1);
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? slides.length - 1 : prevIndex - 1));
  };

  const nextSlide = () => {
    setDirection(1);
    setCurrentIndex((prevIndex) => (prevIndex === slides.length - 1 ? 0 : prevIndex + 1));
  };

  const calcTranslate = (x, y) => {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    const offsetX = (x - windowWidth / 3) / 20; // Adjust divisor for more/less parallax
    const offsetY = (y - windowHeight / 3) / 20;

    return { offsetX, offsetY };
  };

  const { offsetX, offsetY } = calcTranslate(mouseX, mouseY);

  return (
    <section className="slider-container min-h-screen lg:min-h-screen flex items-center bg-cover bg-no-repeat bg-center relative">
      <AnimatePresence custom={direction}>
        <motion.div
          key={currentIndex}
          custom={direction}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{ duration: 0.5 }}
          className="slider-background min-h-screen w-full absolute top-0 left-0"
          style={{
            backgroundImage: slides[currentIndex].backgroundImage,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
        </motion.div>
      </AnimatePresence>

      <AnimatePresence>
        {([0, 1, 2].includes(currentIndex)) && (
          <>
            <motion.img
              key={currentIndex + 'leaf1'}
              src={leaf1}
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1, x: offsetX / 2, y: offsetY / 2 }}
              exit={{ y: 50, opacity: 0 }}
              transition={{ duration: 0.5 }}
              className={`absolute ${getLeafPosition(currentIndex, 1)} z-50`}
            />
            <motion.img
              key={currentIndex + 'leaf2'}
              src={leaf2}
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1, x: offsetX / 1.5, y: offsetY / 1.5 }}
              exit={{ y: 50, opacity: 0 }}
              transition={{ duration: 0.5 }}
              className={`absolute ${getLeafPosition(currentIndex, 2)} z-50`}
            />
            <motion.img
              key={currentIndex + 'leaf3'}
              src={leaf3}
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1, x: offsetX / 1.2, y: offsetY / 1.2 }}
              exit={{ y: 50, opacity: 0 }}
              transition={{ duration: 0.5 }}
              className={`absolute ${getLeafPosition(currentIndex, 3)} z-50`}
            />
            <motion.img
              key={currentIndex + 'leaf4'}
              src={leaf4}
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1, x: offsetX, y: offsetY }}
              exit={{ y: 50, opacity: 0 }}
              transition={{ duration: 0.5 }}
              className={`absolute ${getLeafPosition(currentIndex, 4)} z-50`}
            />
          </>
        )}
      </AnimatePresence>

      <button
        className="prev-button top-1/2 transform -translate-y-1/2 px-4 py-2 text-4xl rounded-full absolute left-4 z-10"
        onClick={prevSlide}
      >
        ❮
      </button>
      <button
        className="next-button top-1/2 transform -translate-y-1/2 px-4 py-2 text-4xl rounded-full absolute right-4 z-10"
        onClick={nextSlide}
      >
        ❯
      </button>
    </section>
  );
};

const getLeafPosition = (currentIndex, leafIndex) => {
  switch (currentIndex) {
    case 0:
      return getLeafPositionForSlide1(leafIndex);
    case 1:
      return getLeafPositionForSlide2(leafIndex);
    case 2:
      return getLeafPositionForSlide3(leafIndex);
    default:
      return '';
  }
};

const getLeafPositionForSlide1 = (leafIndex) => {
  switch (leafIndex) {
    case 1:
      return 'bottom-[-7%] right-[20%]';
    case 2:
      return 'top-[-10%] left-[10%]';
    case 3:
      return 'top-[5%] right-[-5%]';
    case 4:
      return 'bottom-[5%] left-[-2%]';
    default:
      return '';
  }
};

const getLeafPositionForSlide2 = (leafIndex) => {
  switch (leafIndex) {
    case 1:
      return 'bottom-[-7%] right-[70%] rotate-[60deg]';
    case 2:
      return 'top-[5%] left-[60%] rotate-[60deg]';
    case 3:
      return 'top-[70%] right-[10%]';
    case 4:
      return 'bottom-[70%] left-[5%]';
    default:
      return '';
  }
};

const getLeafPositionForSlide3 = (leafIndex) => {
  switch (leafIndex) {
    case 1:
      return 'bottom-[7%] right-[65%]';
    case 2:
      return 'top-[-8%] left-[60%] rotate-[60deg]';
    case 3:
      return 'top-[75%] right-[20%]';
    case 4:
      return 'bottom-[60%] left-[20%]';
    default:
      return '';
  }
};

export default ImageSlider2;